export const ICON_PATHS: Record<string, string> = {
  logo: "M6 8.5A4.5 4.5 0 0 1 10.5 4h11A4.5 4.5 0 0 1 26 8.5v9a4.5 4.5 0 0 1-4.5 4.5H16l-6.5 5v-5A4.5 4.5 0 0 1 5 17.5v-9Z M11 11h10 M11 15h7",
  home: "M3 11.5 12 4l9 7.5M5.5 10v10h13V10M9 20v-6h6v6",
  monitor: "M4 5h16v11H4zM8 20h8M12 16v4",
  calendar: "M5 3v3M19 3v3M4 8h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1z",
  check: "m5 12 4 4L19 6",
  alert: "M12 3 2.5 20h15zM12 9v5M12 18h.01",
  users:
    "M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M17 11a3 3 0 1 0 0-6M21 21v-2a4 4 0 0 0-3-3.87",
  pulse: "M3 12h4l2-7 4 14 2-7h6",
  shield: "M12 3 20 6v6c0 5-3.4 8.3-8 10-4.6-1.7-8-5-8-10V6zM9 12l2 2 4-5",
  plus: "M12 5v14M5 12h14",
  grid: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  download: "M12 3v12m-4-4 4 4 4-4M4 19h16",
  clipboard: "M9 5h6M9 3h6v4H9zM6 5H5v16h14V5h-1",
  search: "M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zM16 16l5 5",
  filter: "M4 5h16l-6 7v6l-4 2v-8z",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
  external: "M14 4h6v6M20 4l-9 9M18 13v6H5V6h6",
  flask: "M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3M8 15h8",
  arrow: "M5 12h14m-6-6 6 6-6 6",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0",
  accessibility: "M12 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM4 8h16M12 8v6m0 0-4 7m4-7 4 7M8 11l4 3 4-3",
  history: "M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5M12 7v5l3 2",
  layout: "M4 4h16v16H4zM4 9h16M10 9v11",
  message: "M4 5h16v12H8l-4 4z",
  sliders: "M4 6h5M15 6h5M12 3v6M4 12h9M17 12h3M15 9v6M4 18h3M11 18h9M9 15v6",
  lock: "M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5z",
  play: "M8 5l11 7-11 7z",
  video: "M3 6h13v12H3zM16 10l5-3v10l-5-3",
  link: "M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1",
  inbox: "M4 4h16v16H4zM4 14h5l2 3h2l2-3h5",
  database: "M4 6c0-2 16-2 16 0s-16 2-16 0zm0 0v12c0 2 16 2 16 0V6M4 12c0 2 16 2 16 0",
  archive: "M4 7h16v14H4zM3 3h18v4H3zM9 11h6",
  clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2",
  book: "M4 4h6a3 3 0 0 1 3 3v13a3 3 0 0 0-3-3H4zM20 4h-6a3 3 0 0 0-3 3v13a3 3 0 0 1 3-3h6z",
  file: "M6 3h8l4 4v14H6zM14 3v5h5",
  send: "M3 11l18-8-8 18-2-7zM11 14l10-11",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4",
  gear: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8-3 2-1-2-4-2 .5-1.5-1.5.5-2-4-2-1 2-2 .5-1.5 1.5.5 2-2 4 2 1 2 2 4-2 1-2 2-.5 1.5-1.5-.5-2z",
  menu: "M4 6h16M4 12h16M4 18h16",
  close: "M5 5l14 14M19 5 5 19",
  globe: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM2 12h20M12 2c3 3 3 17 0 20M12 2c-3 3-3 17 0 20",
  chevron: "m9 6 6 6-6 6",
  crown: "M3 7l4 5 5-8 5 8 4-5-2 12H5z",
  logout: "M10 4H4v16h6M14 8l4 4-4 4M18 12H8",
  copy: "M8 8h11v12H8zM5 16H4V4h11v1",
  camera: "M4 7h4l2-2h4l2 2h4v12H4zM12 10a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
  mic: "M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5 11a7 7 0 0 0 14 0M12 18v3M9 21h6",
  document: "M6 3h9l3 3v15H6zM9 11h6M9 15h6M9 7h3",
  tag: "M3 12V5h7l11 11-7 7zM7.5 8.5h.01",
  trash: "M4 6h16M9 6V4h6v2M7 6l1 15h8l1-15",
  star: "M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9z",
  help: "M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.9.4-1.4 1-1.4 2.2M12 18h.01M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
};
